export const RouteConstants = {
    'savedQueryName': 'savedQueryName',
    'savedQueryOwner': 'owner',
    'query': 'query',
    // same as savedQueryName but for shared queries - this is how WB handles it
    'name': 'name',
    // same as savedQueryOwner but for shared queries - this is how WB handles it
    'owner': 'owner'
};
